import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../../services/reports.service';
import { HelpersService } from '../../../../services/helpers.service';
import moment from 'moment';
import * as XLSX from 'xlsx';

import * as json2csv from 'json2csv'; // convert json file to csv

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  public partnerID: number;
  public availableReports: any = [];
  public reports: any = [];
  public selectedReport: string = null;
  public reportData: any = [];
  public startDate: any;
  public endDate: any;
  public loading: boolean = false;
  public runningReport: boolean = false;
  public reportRan: boolean = false;
  public useTableBorder: boolean = true;
  public csvFileName = `report.csv`;

  Json2csvParser = json2csv.Parser;

  constructor(
    public reportService: ReportService,
    public helpersService: HelpersService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.loading = true;
    this.reportService.getReportList().subscribe((availableReports) => {
      this.reports = availableReports;
      this.availableReports = [];
      availableReports.forEach((report) => {
        var filteredData = this.availableReports.filter((filter) => {
          return filter.label === report.ReportGroup;
        });
        if (filteredData.length > 0) {
          filteredData[0].items.push({
            label: report.ReportName,
            value: report.ReportName,
          });
        } else {
          this.availableReports.push({
            label: report.ReportGroup,
            items: [{ label: report.ReportName, value: report.ReportName }],
          });
        }
      });
      this.loading = false;
    });

    this.startDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 1);
    this.endDate = new Date();
    this.endDate.setDate(this.startDate.getDate() + 2);
  }

  runReport() {
    this.runningReport = true;
    this.reportRan = false;
    this.reportService
      .getReportData(
        this.selectedReport,
        this.partnerID,
        moment(this.startDate).format('YYYYMMDD'),
        moment(this.endDate).format('YYYYMMDD'),
      )
      .subscribe(
        (reportData) => {
          this.reportData = reportData;
          this.useTableBorder =
            reportData.length > 0 &&
            reportData[0].length > 0 &&
            reportData[0][0].length > 0
              ? true
              : false;
          this.runningReport = false;
          this.reportRan = true;
        },
        (error) => {
          this.runningReport = false;
          this.reportRan = false;
        },
      );
  }

  public downloadFile() {
    var ws = XLSX.utils.json_to_sheet(this.reportData);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');
    XLSX.writeFile(wb, this.selectedReport.toLowerCase() + '.xlsx');

    //var f = XLSX.utils.json_to_sheet(this.reportData);
    //let file = new Blob([this.reportData], { type: 'text/xslx;charset=utf-8' });
    //saveAs(file, this.selectedReport.toLowerCase() + ".xslx");

    //console.log(this.reportData);
    //let csvData = this.convertToCSV(this.reportData);
    //let file = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    //saveAs(file, this.selectedReport.toLowerCase() + ".csv");
  }

  public convertToCSV(objArray: any, fields?) {
    let json2csvParser = new this.Json2csvParser({
      opts: fields,
      quote: '"',
      withBOM: true,
      header: false,
    });
    let csv = json2csvParser.parse(objArray);
    return csv;
  }

  public getReportDescription() {
    if (this.selectedReport) {
      var report = this.reports
        .filter((x) => {
          return x.ReportName === this.selectedReport;
        })
        .pop();
      if (report) {
        return report.ReportDescription;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
